export default "__VITE_ASSET__DxDwLcAr__"